/**
 * Converts a full state name to its 2-letter abbreviation
 * @param {string} stateName - The full state name (e.g., "New York")
 * @returns {string|null} - The 2-letter abbreviation (e.g., "NY") or null if not found
 */

// Alternative version with hardcoded mapping for better performance
export const getUsaStateAbbreviation = (stateName) => {
  if (!stateName || typeof stateName !== "string") {
    return null;
  }

  const stateMap = {
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    "district of columbia": "DC",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    massachusetts: "MA",
    maryland: "MD",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    washington: "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY",
  };

  const normalizedStateName = stateName?.trim()?.toLowerCase();
  return stateMap[normalizedStateName] || null;
};
